/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_Col_DesktopInputs */

const en_pc_online_cmp_col_desktop = /** @type {(inputs: Pc_Online_Cmp_Col_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop app`)
};

const zh_pc_online_cmp_col_desktop = /** @type {(inputs: Pc_Online_Cmp_Col_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桌面版`)
};

/**
* | output |
* | --- |
* | "Desktop app" |
*
* @param {Pc_Online_Cmp_Col_DesktopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_col_desktop = /** @type {((inputs?: Pc_Online_Cmp_Col_DesktopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_Col_DesktopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_col_desktop(inputs)
	return zh_pc_online_cmp_col_desktop(inputs)
});
export { pc_online_cmp_col_desktop as "pc.online.cmp.col_desktop" }